/* @flow */

export default class ConfirmEligibilityAnswersRequest {
  leadId: number;

  constructor(leadId: number) {
    this.leadId = leadId;
  }
}
